import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import * as styles from './ProgressBar.css';

const cx = classNames.bind(styles);

/**
 * Calculates progress percentage, clamped 0–100.
 */
export const calculateProgress = (progressCompleted, threshold) => {
    if (!threshold || threshold === 0) return 0;
    return Math.min(Math.round((progressCompleted / threshold) * 100), 100);
};

const ProgressBar = ({ progressCompleted, threshold, variant }) => {
    const percentage = calculateProgress(progressCompleted, threshold);
    // Minimum width for the filled bar so the text is always visible
    const fillWidth = percentage === 0 ? '23px' : `${percentage}%`;
    const isGrey = variant === 'grey';
    const hasProgress = !isGrey && progressCompleted > 0;

    return (
        <div className={cx('progressBarWrapper')}>
            <div className={cx('progressBarTrack')}>
                <div
                    className={cx('progressBarFill', {
                        progressBarFillActive: hasProgress,
                        progressBarFillGrey: isGrey,
                        progressBarFillEmpty: !hasProgress && !isGrey,
                    })}
                    style={{ width: fillWidth }}
                >
                    <span className={cx('progressBarText')}>{progressCompleted}</span>
                </div>
            </div>
            <span className={cx('thresholdText')}>{threshold}</span>
        </div>
    );
};

ProgressBar.propTypes = {
    progressCompleted: PropTypes.number.isRequired,
    threshold: PropTypes.number.isRequired,
    variant: PropTypes.oneOf(['default', 'grey']),
};

ProgressBar.defaultProps = {
    variant: 'default',
};

export default ProgressBar;
